<template>
  <div
    v-if="visible"
    :class="`rd-modal ${visible && 'rd-modal--visible'}`"
    :style="{ height: `${height}px` }"
  >
    <div class="rd-modal__header">
      <slot name="header"></slot>
    </div>
    <div id="modal-content" data-testid="modal-content" class="rd-modal__content">
      <slot name="content"></slot>
    </div>
    <div class="rd-modal__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RDModal',
  data: () => ({
    visible: false,
    height: global.innerHeight
  }),
  created() {
    global.window.addEventListener('resize', () => {
      this.height = global.innerHeight
    })
  },
  watch: {
    visible(value) {
      const sbContainer = document.querySelector('.entity-hero')

      if (value) {
        document.body.style.overflow = 'hidden'
        if (sbContainer) sbContainer.style.zIndex = '0'
      } else {
        document.body.style.overflow = ''
        if (sbContainer) sbContainer.style.zIndex = ''
      }
    }
  },
  methods: {
    open() {
      this.visible = true
      global.flowSingleStep.step1.load({
        closeHandler: () => {
          this.visible = false
        }
      })
      // global.stackAction('modal', () => {
      //   this.visible = false
      // })
    },
    close() {
      global.flowSingleStep.step1.forceBack()
      // global.unstackAction('modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.rd-modal {
  display: none;
  flex-direction: column;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: white;
  height: 100%;

  &--visible {
    display: flex;
  }

  &__header {
    width: 100%;
    height: 6rem;
    border-bottom: solid 1px #dedede;
  }

  &__content {
    height: calc(100% - 12rem);
  }

  &__footer {
    width: 100%;
    height: 6rem;
  }
}
</style>
